import { Action } from 'redux';
import { select, put } from 'redux-saga/effects';
import { DeliveryTypes } from 'models';
import { BasketErrorModel } from 'models/Errors';
import { BasketActionTypes, BasketActions } from '../';
import { AppState, ErrorAction } from 'store';
import { userHelper, ACTION_CREATOR_NAME, errorToBasketErrorModel } from 'helpers';
import { api } from 'repositories/api';
import { initBasketPageSaga } from './initBasketPage';
import { validateBasketReservationsSaga } from './validation/validateBasketReservations';
import { basketStorage } from 'storages';
import { BasketSagaReturnType, callBasketSaga } from 'store/sagaHelpers';

const RESERVATION_ERROR_MESSAGE = 'Reservation has expired (set delivery type)';

export interface SetDeliveryTypeAction extends Action<BasketActionTypes.SET_DELIVERY_TYPE> {
    deliveryType: DeliveryTypes;
}

export interface SetDeliveryTypeActionStart extends Action<BasketActionTypes.SET_DELIVERY_TYPE_START> {
}

export interface SetDeliveryTypeActionSuccess extends Action<BasketActionTypes.SET_DELIVERY_TYPE_SUCCESS> {
}

export interface SetDeliveryTypeActionError extends ErrorAction<BasketActionTypes.SET_DELIVERY_TYPE_ERROR> {
}

export const setDeliveryType: (deliveryType: DeliveryTypes) => SetDeliveryTypeAction = (deliveryType: DeliveryTypes) => ({
    type: BasketActionTypes.SET_DELIVERY_TYPE,
    deliveryType
});
setDeliveryType[ACTION_CREATOR_NAME] = 'setDeliveryType';

export type SetDeliveryTypeFunc = (...args: Parameters<typeof setDeliveryType>) => void;

export function* setDeliveryTypeSaga({ deliveryType }: SetDeliveryTypeAction): BasketSagaReturnType {
    yield put<BasketActions>({
        type: BasketActionTypes.SET_DELIVERY_TYPE_START
    });

    try {
        // do reservation validation also before set delivery type api call
        // because this call removes (in background) expired items from the basket
        // therefore it won't be possible to catch the reservation expiration event from initBasketSaga
        yield callBasketSaga(validateBasketReservationsSaga, {
            type: BasketActionTypes.VALIDATE_BASKET_RESERVATIONS,
            isBasketPage: true
        });

        let state: AppState = yield select();

        if (state.basketState.shouldShowReservationWarning) {
            throw new BasketErrorModel(RESERVATION_ERROR_MESSAGE, undefined, 'setDeliveryTypeSaga');
        }

        yield api.hybris.setDeliveryType(deliveryType, userHelper.getCurrentUserName(), state.basketState.basket!.guid);
        basketStorage.saveDeliveryType(deliveryType);

        yield callBasketSaga(initBasketPageSaga, {
            type: BasketActionTypes.INIT_BASKET_PAGE
        });

        yield put<BasketActions>({
            type: BasketActionTypes.SET_DELIVERY_TYPE_SUCCESS
        });

        return true;
    } catch (error) {
        yield put<BasketActions>({
            type: BasketActionTypes.SET_DELIVERY_TYPE_ERROR,
            error: errorToBasketErrorModel(error, 'setDeliveryTypeSaga')
        });

        return false;
    }
}